import { render, staticRenderFns } from "./MDinterview.vue?vue&type=template&id=5c082b7c"
import script from "./MDinterview.vue?vue&type=script&lang=js"
export * from "./MDinterview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports